import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaAirbnb } from 'react-icons/fa';

const reviews = [
  {
    stars: 5,
    text: 'Os meninos são bem receptivos deram informações úteis, local de fácil acesso a praça principal, boa acomodação custo benefício!',
    author: 'Danielle, Março de 2025',
    avatar: 'https://a0.muscache.com/im/pictures/user/fb184275-14ae-4424-bc0d-b31ce8521e4a.jpg?im_w=720'
  },
  {
    stars: 5,
    text: 'Um lugar muito agradável e tranquilo, o quarto muito limpo e organizado.',
    author: 'Felipe, Fevereiro de 2025',
    avatar: 'https://a0.muscache.com/im/pictures/user/User-154759204/original/b40261b8-b1f0-4348-8870-66e288712618.jpeg?im_w=720'
  },
  {
    stars: 5,
    text: 'Um ambiente muito tranquilo, a localização é excelente próximo de vários pontos turístico e o quarto tem um vista incrível.',
    author: 'Marcio, Janeiro de 2025',
    avatar: 'https://a0.muscache.com/im/pictures/user/User/original/bb3e2475-06a0-47cd-8d72-64c06648d9ca.jpeg?im_w=720'
  }
];

export default function HospedagemSection() {
    const [index, setIndex] = useState(0);
    const nextReview = () => setIndex((index + 1) % reviews.length);
    const prevReview = () => setIndex((index - 1 + reviews.length) % reviews.length);
  
    // Auto play a cada 6 segundos
    useEffect(() => {
      const interval = setInterval(() => {
        setIndex(prev => (prev + 1) % reviews.length);
      }, 6000);
      return () => clearInterval(interval);
    }, []);
    
  
    return (
      <section
        style={{
          minHeight: '500px',
          width: '100%',
          background: 'linear-gradient(to right, #07223A, #0779FF)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
          color: 'white',
          padding: '2rem',
          flexWrap: 'wrap',
          gap: '2rem'
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          style={{ maxWidth: '600px', minWidth: '280px' }}
        >
          <h2 style={{ fontSize: '2.2rem', fontWeight: '600', marginBottom: '1rem' }}>
            Viva o melhor de Ouro Preto
          </h2>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
            Hospede-se na <strong>República Sem Destino</strong> e descubra uma nova forma de viver a cidade.
            Acolhimento, conforto e localização estratégica para tornar sua experiência única.
          </p>
          <motion.a
            href="https://www.airbnb.com.br/users/show/32669058"
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.05, backgroundColor: '#FF5A5F', color: 'white' }}
            transition={{ duration: 0.3 }}
            style={{
              marginTop: '1.5rem',
              display: 'inline-flex',
              alignItems: 'center',
              padding: '0.8rem 1.6rem',
              fontSize: '1rem',
              backgroundColor: '#DCE6F1',
              color: '#07223A',
              borderRadius: '30px',
              fontWeight: '600',
              textDecoration: 'none',
              transition: '0.3s ease',
              gap: '0.5rem'
            }}
          >
            <FaAirbnb size={20} />
            Veja no Airbnb
          </motion.a>
        </motion.div>
  
        <motion.div
          style={{
            backgroundColor: 'white',
            color: '#07223A',
            padding: '2rem',
            borderRadius: '16px',
            maxWidth: '420px',
            minWidth: '280px',
            boxShadow: '0 10px 20px rgba(0,0,0,0.15)',
            position: 'relative',
            minHeight: '260px',
            overflow: 'hidden'
          }}
        >
          <AnimatePresence mode="wait">
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: -20, scale: 0.95 }}
              transition={{ duration: 0.5 }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem' }}>
                <img
                  src={reviews[index].avatar}
                  alt={reviews[index].author}
                  style={{ width: '48px', height: '48px', borderRadius: '50%', objectFit: 'cover' }}
                />
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                    {[...Array(reviews[index].stars)].map((_, i) => (
                      <span key={i} style={{ color: '#FFD700', fontSize: '1.2rem' }}>★</span>
                    ))}
                    <span style={{ fontWeight: '600', marginLeft: '0.5rem' }}>5,0</span>
                  </div>
                  <p style={{ fontWeight: '600', fontSize: '0.95rem', marginTop: '0.2rem' }}>{reviews[index].author}</p>
                </div>
              </div>
              <p style={{ fontStyle: 'italic' }}>{reviews[index].text}</p>
            </motion.div>
          </AnimatePresence>
  
          {/* Botões de navegação */}
          <div style={{ position: 'absolute', bottom: '1rem', right: '1rem', display: 'flex', gap: '1rem' }}>
            <button onClick={prevReview} style={btnStyle}>{'<'}</button>
            <button onClick={nextReview} style={btnStyle}>{'>'}</button>
          </div>
  
          {/* Indicadores de posição clicáveis */}
          <div style={{
            position: 'absolute',
            bottom: '1rem',
            left: '1rem',
            display: 'flex',
            gap: '0.4rem'
          }}>
            {reviews.map((_, i) => (
              <span
                key={i}
                onClick={() => setIndex(i)}
                style={{
                  width: '10px',
                  height: '10px',
                  borderRadius: '50%',
                  backgroundColor: i === index ? '#0779FF' : '#ccc',
                  cursor: 'pointer',
                  transition: '0.3s ease'
                }}
              />
            ))}
          </div>
        </motion.div>
      </section>
    );
  }
  
  const btnStyle = {
    backgroundColor: '#0779FF',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    cursor: 'pointer',
    fontSize: '1rem'
  };
  